import { render } from "./Search.vue?vue&type=template&id=ff07f352&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=ff07f352&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ff07f352"

export default script